<template>
  <div class="loadingView" v-if="loadingForm">
    <LoadingList v-model="loadingForm" text="Carregando dados." />
  </div>
  <div v-else>
    <RequiredFieldsMessage :cmeTerms="false" />
    <div>
      <b-row class="information">
        <b-col>
          <p v-if="showContract">Insira abaixo os documentos solicitados.</p>
        </b-col>

        <div class="w-100"></div>
        <b-col>
          <div class="upload-files" v-if="showContract">
            <b-row align-v="center">
              <b-col>
                <h5><span class="required red">*</span> Contrato Assinado</h5>
                <p class="mb-4" v-if="enrollment.EnrollmentFile">
                  Enviado para o seu e-mail para assinatura digital.
                  <br />
                  <span
                    v-if="
                      enrollment.EnrollmentFile.sign_contract_a_url &&
                      !enrollment.signed_at
                    "
                  >
                    <strong>Contratante A</strong> -
                    <a
                      :href="enrollment.EnrollmentFile.sign_contract_a_url"
                      target="_blank"
                      class="purple underline"
                      >Clique aqui para assinar o seu Contrato</a
                    >
                  </span>
                  <br />
                  <span
                    v-if="
                      enrollment.EnrollmentFile.sign_contract_b_url &&
                      !enrollment.signed_at
                    "
                  >
                    <strong>Contratante B</strong> -
                    <a
                      :href="enrollment.EnrollmentFile.sign_contract_b_url"
                      target="_blank"
                      class="purple underline"
                      >Clique aqui para assinar o seu Contrato</a
                    >
                  </span>
                </p>
              </b-col>

              <b-col class="text-right" v-if="!enrollment.signed_at">
                <span target="_blank" class="upload holding btn"
                  >Aguardando assinatura</span
                >
              </b-col>

              <b-col cols="4" class="text-right" v-else>
                <a target="_blank" class="upload done btn contract"
                  >Assinado!</a
                >
              </b-col>
            </b-row>
          </div>
          <div v-if="showContract">
            <div
              class="upload-files file-row"
              v-for="(document, index) in sortedValue"
              :key="`doc-${index}-${document.title}`"
            >
              <h5 class="mb-4" style="padding-top: 10px">
                <span v-if="document.isRequired" :class="isRequired()">*</span>
                {{ document.title }}
              </h5>

              <div
                v-for="(file, fIndex) in document.files"
                :key="file.fileName + '-' + fIndex"
              >
                <b-row class="m-b align-items-center">
                  <b-col cols="4">
                    <b-form-file
                      accept=".pdf"
                      :value="file.file"
                      @input="(f) => setFile(file, f)"
                      plain
                    ></b-form-file>
                  </b-col>

                  <b-col cols="4" class="text-center">
                    <b-form-checkbox
                      v-if="not_applicable_files.includes(file.fileName)"
                      name="nao-se-aplica"
                      :value="true"
                      v-model="file.notApplicable"
                      @change="changeNotApplicable(file)"
                    >
                      Não se aplica
                    </b-form-checkbox>
                  </b-col>

                  <b-col cols="4" class="text-right">
                    <a
                      v-if="file.status && file.url !== 'notApplicable'"
                      target="_blank"
                      :href="file.url"
                      class="upload done btn"
                    >
                      Enviado!
                    </a>
                    <span
                      v-else-if="file.status && file.url === 'notApplicable'"
                      class="upload done btn"
                      style="cursor: default"
                    >
                      Enviado!
                    </span>

                    <span v-else-if="file.isInvalid" class="upload invalid btn">
                      Inválido
                    </span>

                    <div
                      v-else-if="!file.status && file.progress !== null"
                      class="progress-wrapper"
                    >
                      <div class="progress-bar">
                        <div
                          class="progress-bar-inner"
                          :style="{ width: file.progress + '%' }"
                        ></div>
                        <span class="progress-text">{{ file.progress }}%</span>
                      </div>
                    </div>
                    <span v-else class="upload not-sent btn">
                      Não enviado
                    </span>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LoadingList from "@/components/LoadingList.vue";
import httpRda from "../../../http-rda";
import { sortEnrollmentDocuments } from "../../../utils/sortEnrollmentFiles";
import RequiredFieldsMessage from "@/components/RequiredFieldsMessage.vue";

export default {
  name: "Submit",
  components: {
    LoadingList,
    RequiredFieldsMessage,
  },
  props: {
    value: [],
    enrollmentId: null,
    editedUserId: null,
    enrollmentMeta: null,
  },

  data() {
    return {
      enrollmentYear: null,
      loadingForm: true,
      rdaUnit: process.env.VUE_APP_RDA_UNIT,
      showDocs: null,
      showContract: true,
      enrollment: {},
      is_re_enroll: false,
      is_re_enroll_updated: false,
      not_applicable_files:
        process.env.VUE_APP_RDA_UNIT === "BELO_HORIZONTE"
          ? [
              "identity_back",
              "cpf",
              "transference_declaration",
              "discharge",
              "identity_contractor_a_back",
              "identity_contractor_b_back",
              "cpf_contractor_a",
              "cpf_contractor_b",
              "school_record",
            ]
          : [],
    };
  },

  methods: {
    ...mapActions({
      submitDocument: "enrollment/submitDocument",
      finishEnrollment: "enrollment/finishEnrollment",
      getFilesEnrollment: "enrollment/enrollment",
    }),

    applyEnrollmentMeta(meta) {
      this.enrollment = meta;
      this.is_re_enroll = !!meta?.EnrollmentStudent?.is_re_enroll;

      this.fillDocument();

      this.enrollmentYear = meta.Calendar ? meta.Calendar.designation : null;

      this.showContract = !(["2022", "2023"].includes(this.enrollmentYear) && this.rdaUnit === "POUSO_ALEGRE");

      this.loadingForm = false;
    },

    async submitFile(file) {
      const bodyFormData = new FormData();
      bodyFormData.append("fileName", file.fileName);

      if (this.editedUserId) {
        bodyFormData.append("notification", true);
        bodyFormData.append("edited_user_id", this.editedUserId);
      }

      if (file.file) {
        bodyFormData.append("file", file.file);
      } else if (file.notApplicable) {
        bodyFormData.append("file", "notApplicable");
      } else {
        alert("Selecione um arquivo para enviar.");
        return;
      }

      file.status = false;
      file.progress = 0;
      file.isInvalid = false;

      try {
        await httpRda
          .post(`/enrollments/${this.enrollmentId}/files`, bodyFormData, {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              if (progressEvent.lengthComputable) {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                file.progress = percent;
                this.$forceUpdate();
              } else {
                file.progress = file.progress || 1;
              }
            },
          })
          .then((response) => {
            file.url = response.data.url;
            file.status = true;
            file.progress = 100;

            if (response.data.is_invalid === true) {
              file.isInvalid = true;
            }
          });

        this.$forceUpdate();
      } catch (error) {
        file.status = false;
        file.progress = null;
        alert("Falha ao enviar o arquivo. Tente novamente.");
      }
    },

    setFile(file, f) {
      if (f) {
        file.progress = null;
        file.status = false;
        file.file = f;
        file.notApplicable = false;
        file.url = "";

        this.submitFile(file);
      }
    },

    async fillDocument() {
      if (
        this.enrollment !== undefined &&
        this.enrollment.EnrollmentFile !== undefined &&
        this.enrollment.EnrollmentFile.id !== undefined
      ) {
        for (const key in this.enrollment.EnrollmentFile) {
          this.value.forEach((keyValue) => {
            for (const data of keyValue.files) {
              if (key === data.fileName) {
                data.url = this.enrollment.EnrollmentFile[key];
                data.status = data.url !== null ? true : false;
                data.notApplicable = data.url === "notApplicable";
              }

              if (
                (key === "vaccination_record" &&
                  data.fileName === "vaccination_record" &&
                  this.is_re_enroll) ||
                (key === "proof_of_residence" &&
                  data.fileName === "proof_of_residence" &&
                  this.is_re_enroll)
              ) {
                data.url = null;
                data.status = false;
              }
            }
          });
          this.value[0].signed_at = this.enrollment.signed_at;
        }
      }
    },

    async setIsReEnroll() {
      await httpRda.patch(
        `/enrollments/${this.enrollmentId}/files/isreenroll`,
        {
          is_re_enroll: this.is_re_enroll,
        }
      );
    },

    isRequired() {
      if (this.rdaUnit === "BELO_HORIZONTE") {
        return "required red";
      }
      return "";
    },

    onFileSelected(file) {
      if (file.file) {
        file.notApplicable = false;
        file.url = "";
        file.status = false;
      }
    },

    changeNotApplicable(file) {
      file.status = false;
      if (!file.notApplicable) {
        file.url = "";
        file.progress = null;
        file.file = null;
        file.status = false;
      } else {
        file.url = "";
        file.progress = null;
        file.file = null;

        this.submitFile(file);
      }
    },

    shouldShowSendButton(file) {
      return (
        (!file.status && !file.progress) ||
        (file.notApplicable && file.url !== "notApplicable") ||
        (!file.notApplicable && file.url === "notApplicable")
      );
    },
  },

  computed: {
    ...mapGetters({
      files: "enrollment/getFiles",
    }),

    allFiles() {
      if (!this.showDocs) {
        return true;
      }
      if (this.files == null) {
        return false;
      }

      const hasSubmitAllFiles = [
        this.files.identity,
        this.files.identity_back,
        this.files.cpf,
        this.files.vaccination_record,
        this.files.discharge,
        this.files.identity_contractor_a,
        this.files.identity_contractor_a_back,
        this.files.identity_contractor_b,
        this.files.identity_contractor_b_back,
        this.files.cpf_contractor_a,
        this.files.cpf_contractor_b,
      ];

      return hasSubmitAllFiles.every((a) => a !== null);
    },
    sortedValue() {
      if (!this.value || !Array.isArray(this.value)) {
        return [];
      }
      return sortEnrollmentDocuments(this.value);
    },
  },

  watch: {
    file() {
      if (this.value)
        this.value.map((doc) => {
          doc.files.map((file) => {
            const f = this.files[file.fileName];
            if (!f) return;

            file.url = f;
            file.status = true;
            file.progress = 100;
            file.isInvalid = this.files["is_valid_" + file.fileName] === false;
          });
        });
    },

    enrollmentMeta: {
      immediate: true,
      handler(val) {
        if (val) {
          this.applyEnrollmentMeta(val);
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.information {
  .form-group {
    margin-bottom: 40px;
  }
}

.m-b {
  margin-bottom: 20px;
}

.file-row {
  padding: 8px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.file-name {
  font-size: 0.85rem;
  color: #555;
  margin-top: 6px;
  word-break: break-word;
}

.progress-wrapper {
  display: inline-block;
  width: 150px;
  position: relative;
  height: 22px;
  background-color: #f1f1f1;
  border-radius: 12px;
  overflow: hidden;
  vertical-align: middle;
}

.progress-bar {
  width: 100%;
  height: 100%;
  position: relative;
}

.progress-bar-inner {
  height: 100%;
  transition: width 0.3s ease-in-out;
}

.progress-text {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-size: 0.85rem;
  color: #fff;
  text-align: center;
  line-height: 22px;
  font-weight: 600;
}

.upload.done.btn,
.upload.invalid.btn,
.upload.holding.btn {
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
}

.red {
  color: red;
}

.not-sent {
  background-color: #f44336 !important;
  color: white !important;
  border: none !important;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  border-color: #f44336 !important;
}

.not-sent:hover {
  background-color: #f44336 !important;
  border-color: #f44336 !important;
}

.not-sent:active {
  color: white !important;
}
</style>
